import React, { useEffect, useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { buy, generatePayID } from '../api/purchase';
import { STATE, STATES, USER_TYPE, PMT } from '../classes/Enum';
import LoginRegisterComponent from './LoginRegister';
import PaymentMethodComponent from './PaymentMethod';
import { Elements } from '@stripe/react-stripe-js';
import { CURRENCY_CODE } from '../config';
import StripePaymentComponent from './StripePayment';

const PaymentForm = ({ setTransactionId, totalPrice, cart, setState, shippingPaid, couponCode, stripePromise, user }) => {
  const [error, setError] = useState(null);
  const [userType, setUserType] = useState(user ? USER_TYPE.EXISTING: USER_TYPE.NEW);
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentMethodOption, setPaymentMethod] = useState(PMT.CARD);
  const [customerInfo, setCustomerInfo] = useState({
    tiktokName: '',
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    postcode: '',
    state: '',
  });
  

  const options = {
    mode: 'payment',
    amount: Math.round(totalPrice * 100),
    currency: CURRENCY_CODE,
    // Fully customizable with appearance API.
    appearance: {/*...*/},
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(name);
    console.log(value);

    setCustomerInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsProcessing(true);
    setError(null);

    try {
        console.log("Using payid.. generating order number");
        console.log(couponCode);
        const response = await generatePayID(totalPrice, cart, customerInfo, shippingPaid, couponCode, user);
        console.log(response);
        setTransactionId(response.transaction);
        setState(STATE.SUCCESS);
    } catch (err) {
      setError('There was an issue fulfilling your PAYID order.');
    }

    setIsProcessing(false);
  };

  const GuestComponent = () => {
    return (<div id="customer-section">
      <form>
        <div className="row">
          <input
            type="text"
            name="tiktokName"
            value={customerInfo.tiktokName}
            onChange={handleInputChange}
            placeholder="TikTok Name"
            required
          />
        </div>
        <div className="row">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={customerInfo.firstName}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={customerInfo.lastName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="row">
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={customerInfo.address}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="city"
            placeholder="City"
            value={customerInfo.city}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="row">
          <input
            type="text"
            name="postcode"
            placeholder="Postcode"
            value={customerInfo.postcode}
            onChange={handleInputChange}
            required
          />
          <select
            name="state"
            value={customerInfo.state}
            onChange={handleInputChange}
            required
          >
            <option value="" disabled>
              Select State
            </option>
            {STATES.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>
      </form>
    </div>)
  };

  const PayIDComponent = () => (
    <div>
      <button id="pay-button" onClick={handleSubmit} disabled={isProcessing}>
        {isProcessing ? 'Processing...' : ("Generate PayID Order: $" + totalPrice + " " +  CURRENCY_CODE.toUpperCase()) }
      </button>
    </div>
  );  

  return (
    <Elements stripe={stripePromise} options={options}>
      <div id="checkout-section">
        {user ? null : <div>
          <button onClick={() => setState(STATE.PROFILE)}>
              <h3>Use Existing</h3>
              <img src="/assets/svgs/person.svg"></img>
          </button>
        </div>}
        {userType === USER_TYPE.NEW ? (
          <div id="customer-section">
            <form>
              <div className="row">
                <input
                  type="text"
                  name="tiktokName"
                  value={customerInfo.tiktokName}
                  onChange={handleInputChange}
                  placeholder="TikTok Name"
                  required
                />
              </div>
              <div className="row">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={customerInfo.firstName}
                  onChange={handleInputChange}
                  required
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={customerInfo.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="row">
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  value={customerInfo.address}
                  onChange={handleInputChange}
                  required
                />
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={customerInfo.city}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="row">
                <input
                  type="text"
                  name="postcode"
                  placeholder="Postcode"
                  value={customerInfo.postcode}
                  onChange={handleInputChange}
                  required
                />
                <select
                  name="state"
                  value={customerInfo.state}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled>
                    Select State
                  </option>
                  {STATES.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
            </form>
          </div>) : null}

        <PaymentMethodComponent setPaymentMethod={setPaymentMethod} />
        {totalPrice <= 0 ? <button type="submit" id="pay-button" disabled={isProcessing}>No payment required. Give me my freebie!</button>: null}
        {paymentMethodOption === PMT.CARD && totalPrice > 0 ?
            < StripePaymentComponent user={user} stripePromise={stripePromise} setIsProcessing={setIsProcessing} setError={setError} totalPrice={totalPrice} cart={cart} customerInfo={customerInfo} shippingPaid={shippingPaid} couponCode={couponCode} setState={setState} /> : null
        }
        {paymentMethodOption === PMT.PAYID && totalPrice > 0 && <PayIDComponent />}
      </div>
    </Elements>)
};

export default PaymentForm;
